import React from 'react';
import './errorpage.css';

const ErrorPage = ({ code = 404, children }) => (
  <div className="error-page">
    <div className="item">
      <img src={require(`../assets/errors/${code}.svg`)} alt="Error 404" />
      <div className="text">
        <h1 className="error-page-code">{code}</h1>
        {children}
      </div>
    </div>
  </div>
);

export default ErrorPage;